import { render, staticRenderFns } from "./DailyReports.vue?vue&type=template&id=2fbb53d4&"
import script from "./DailyReports.vue?vue&type=script&lang=js&"
export * from "./DailyReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports